import { useEffect } from "react"
import { colors } from "../../js/generateSchedule";
import AssignmentEntry from "./AssignmentEntry";

function AssignmentCenter(dates) {
  var date = new Date();
  date.setDate(date.getDate() - date.getDay() + 1);
  //console.log(new Date(date.setDate(date.getDate() + 2)).toDateString().split(" ").slice(0, 3).join(" "));
  return (
    <div className="assignment-center row px-0 mx-0">
      {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((day, i) => {
 var tempDate = new Date(date.getTime())
 var dateString = new Date(tempDate.setDate(tempDate.getDate() + i)).toDateString().split(" ").slice(0, 3).join(" ");
 //console.log(dates.dates, dateString, dates.dates.hasOwnProperty(dateString));
        return (
        <div className="col">
        <h4>{day}</h4>
          <div class="d-flex">
       <ul class="mx-auto justify-content-center">

       
         {dates.dates.hasOwnProperty(dateString) && Object.entries(dates.dates[dateString]).map(([c, assignment], aId) => (
         assignment.hw.length > 0 &&
             
         <li key={dateString+c+aId}><div class="card mt-4" style={{width: "15rem", backgroundColor:colors[assignment.block]}}>
                   <div class="card-body">
                   <h5 class="card-title text-center">{c.split(" ").slice(0, -1).join(" ")}</h5>
                   

                     {assignment.hw.map((a) => (
                        typeof a === "string" ? <p class="card-text pb-0 mb-0">{a}</p> :
                        <AssignmentEntry assignment={{entry:a.entry, desc:a.desc, date:date, className:c.split(" ").slice(0, -1).join(" ")}}/>
                     ))}
               

               </div>
     </div></li>))}
         </ul>
   </div>
   </div>)})}
      

    </div>
  );
}

export default AssignmentCenter;